import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import Gallery from '../components/Gallery';
import TitleWithLanterns from '../components/TitleWithLanterns';

const GalleryPage: React.FC = () => {
  const { t } = useTranslation();

  const galleryItems = [
    // Interior shots
    { src: '/restaurant_photos/_11A5133.JPG', alt: 'Restaurant interior', type: 'image' as const },
    { src: '/restaurant_photos/_11A5149.JPG', alt: 'Seating area', type: 'image' as const },
    { src: '/restaurant_photos/_11A5153.JPG', alt: 'Restaurant decor', type: 'image' as const },
    { src: '/restaurant_photos/_11A5162.JPG', alt: 'Interior design', type: 'image' as const },
    { src: '/restaurant_photos/_11A5166.JPG', alt: 'Dining space', type: 'image' as const },
    { src: '/restaurant_photos/_11A5280.JPG', alt: 'Interior atmosphere', type: 'image' as const },
    
    // Food shots
    { src: '/restaurant_photos/oyster.JPG', alt: 'Fresh oysters', type: 'image' as const },
    { src: '/restaurant_photos/shrimp.JPG', alt: 'Grilled shrimp', type: 'image' as const },
    { src: '/restaurant_photos/IMG_6896.jpg', alt: 'Restaurant food', type: 'image' as const },
    { src: '/restaurant_photos/IMG_6898.jpg', alt: 'Restaurant dishes', type: 'image' as const },
    { src: '/restaurant_photos/IMG_6899.jpg', alt: 'Restaurant cuisine', type: 'image' as const },
    { src: '/restaurant_photos/IMG_6900.jpg', alt: 'Restaurant specialties', type: 'image' as const },
    { src: '/restaurant_photos/IMG_6901.jpg', alt: 'Buffet selection', type: 'image' as const },
    { src: '/restaurant_photos/IMG_6902.jpg', alt: 'Food presentation', type: 'image' as const },
    { src: '/restaurant_photos/IMG_3639.jpg', alt: 'Desserts', type: 'image' as const },
    
    // Additional images
    { src: '/restaurant_photos/IMG_3555.jpeg', alt: 'Restaurant interior detail', type: 'image' as const },
    { src: '/restaurant_photos/IMG_3614.jpeg', alt: 'Restaurant atmosphere', type: 'image' as const },
    { src: '/restaurant_photos/IMG_3618.jpeg', alt: 'Dining experience', type: 'image' as const },
    { src: '/restaurant_photos/IMG_3623.jpeg', alt: 'Restaurant ambiance', type: 'image' as const },
    { src: '/restaurant_photos/IMG_3634 2.jpeg', alt: 'Interior view', type: 'image' as const },
    { src: '/restaurant_photos/IMG_5812.jpeg', alt: 'Restaurant setting', type: 'image' as const },
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative h-[40vh] flex items-center justify-center overflow-hidden bg-luxury-black">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40"
          style={{
            backgroundImage: `url('/restaurant_photos/_11A5133.JPG')`,
          }}
        />
        <div className="absolute inset-0 bg-luxury-gradient" />
        <TitleWithLanterns 
          title={t('gallery.pageTitle', 'Notre Univers en Images')}
          subtitle="Galerie"
          lanternType={4}
        />
      </section>

      <Gallery items={galleryItems} />
    </div>
  );
};

export default GalleryPage;